import { defineStore } from "pinia";
import { ICampanhaStore } from "./types";
import { ICampanhasBook } from "../types";

export const idStore = "useCampanhaNps";

export const useCampanhaStore = defineStore(idStore, {
  state: (): ICampanhaStore => ({
    campanhas: [],
    campanhaAtiva: {
      action: "",
      categoria: "",
      fim: "",
      imagem: "",
      inicio: "",
      link: "",
      localStorageId: "",
      nome: "",
      bloquearClientesPorCodigo: [],
      preventClient: [],
      direcionarCampanha: [],
      direcionarClientesPorCodigo: [],
      validarAntecipa: false,
      mostrarSomenteParaAdmin: false,
      ocultarParaAdmin: false,
      enableWhiteLabelCielo: false,
      exibirSomenteClientesCielo: false
    },
    keyNamePopUp: "",
    userId: "",
    verificacaoConcluida: false,
    popUpAberto: false
  }),
  actions: {
    setCampanhas(value: ICampanhasBook[] | undefined): void {
      if (!value) {
        this.campanhas = [];

        return;
      }

      const campanhasValidas = value?.filter(
        (campanha) =>
          campanha.inicio &&
          campanha.fim &&
          campanha.localStorageId &&
          campanha.nome &&
          campanha.imagem &&
          campanha.link
      );

      this.campanhas = campanhasValidas ?? [];

      this.setKeyNamePopUp();
    },
    setActiveCampanha(value: ICampanhasBook): void {
      if (value) this.campanhaAtiva = value;

      this.setKeyNamePopUp();
    },
    setKeyNamePopUp(): void {
      this.keyNamePopUp = `f360.user.${this.userId}.${this.campanhaAtiva?.localStorageId}`;
    },
    setUserId(value: string | null): void {
      this.userId = value;
    },
    setVerificacaoConcluida(value: boolean): void {
      this.verificacaoConcluida = value;
    },
    setPopUpAberto(value: boolean): void {
      this.popUpAberto = value;
    }
  },
  getters: {
    obterCampanhas(): ICampanhasBook[] {
      return this.campanhas;
    },
    obterCampanhaAtiva(): ICampanhasBook {
      return this.campanhaAtiva;
    }
  }
});
